<template>
  <div id="app" style="">
    <Header v-show="!$route.meta.hideHeader"/>
    <router-view/>
    <Footer v-show="!$route.meta.hideFooter"/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components:{
    Header,
    Footer
  },
  watch: {
    // 监听 $route 属性的变化
    $route(newValue) {
      console.log(newValue)
    },
  },

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
  
  /*设置背景图片*/
  background: url("./assets/top_03.png");
  background-size: 100% ;
  background-repeat: no-repeat;
 
}
body{
  margin: 0;
  padding: 0;
}
.bimg  .login-bg{
  height: 100vh;
  width: 100vw;

  position: absolute;
  
  

  /*设置背景图片*/
  background: url("./assets/login_bg.png");
  background-size: 100% ;
  background-repeat: no-repeat;

}



</style>



// WEBPACK FOOTER //
// src/App.vue